import styled from "styled-components/macro"

export const HelpcenterListWrap = styled.div`
  min-width: 650px;
`
